import SectionStats from './SectionStats';

export default SectionStats;
